﻿import isUndefined from 'lodash/isUndefined';
import Constant from 'utils/constants';

export const isNew = (program) => program?.state === Constant.program.state.new;
export const isStarted = (program) =>
  program?.state === Constant.program.state.started;
export const isCompleted = (program) =>
  program?.state === Constant.program.state.completed;
export const isMaintenance = (program) =>
  program?.state === Constant.program.state.maintenance;
export const isMaintenanceDue = (program) =>
  program?.state === Constant.program.state.maintenanceDue;
export const isQuitted = (program) => program?.state === Constant.program.state.quit;
export const isConsented = (program) =>
  program?.state === Constant.program.state.consented;
export const isDeclined = (program) =>
  program?.state === Constant.program.state.declined;

export const hasTreatmentPlan = (program) => !!program?.treatment_plan;

export const getNextProgramIndex = (program) => {
  return isUndefined(program.program_index) ? 0 : program.program_index + 1;
};

export const getWeekPeriod = (programIndex) => {
  return `${programIndex * 2 + 1}-${programIndex * 2 + 2}`;
};

export const getWeekPeriods = (maxIndex) => {
  const weekPeriods = [];
  for (let i = 0; i <= maxIndex; i++) {
    weekPeriods.push(`${i * 2 + 1}/${i * 2 + 2}`);
  }
  return weekPeriods;
};
